module.exports = __webpack_public_path__ + "img/4.099bdc90.png";